import { render, staticRenderFns } from "./RadioGroupWidget.vue?vue&type=template&id=0369c010&"
import script from "./RadioGroupWidget.vue?vue&type=script&lang=ts&"
export * from "./RadioGroupWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports